import * as Sentry from '@sentry/nuxt';

export type ErrorLoggerMissingDnsKeyHandler = () => void;

export type ErrorLoggerCaptureExceptionFn = (
    exception: any,
    hint?: any
) => string;
export type PossibleCaptureExceptionFn =
    | ErrorLoggerCaptureExceptionFn
    | ErrorLoggerMissingDnsKeyHandler;

export type ErrorLoggerUserData = { id: string };
export type ErrorLoggerSetUserFn = (userData: ErrorLoggerUserData) => void;

export type UseErrorLoggerReturnKeys =
    | 'errorLoggerCaptureException'
    | 'errorLoggerSetUser';

export type UseErrorLoggerMissingDnsKeyReturn = Record<
    UseErrorLoggerReturnKeys,
    ErrorLoggerMissingDnsKeyHandler
>;

export type UseErrorLoggerDnsKeyReturn = {
    errorLoggerCaptureException: ErrorLoggerCaptureExceptionFn;
    errorLoggerSetUser: ErrorLoggerSetUserFn;
};

export type UseErrorLoggerReturn<T extends boolean> = T extends true
    ? UseErrorLoggerDnsKeyReturn
    : UseErrorLoggerMissingDnsKeyReturn;

const displayMissingKeyWarn: ErrorLoggerMissingDnsKeyHandler = () =>
    console.warn('Sentry DNS key is missing');

const errorLoggerMethodsFactory = <T extends boolean>(hasKey: T) => {
    return (
        hasKey
            ? {
                  errorLoggerCaptureException: Sentry.captureException,
                  errorLoggerSetUser: Sentry.setUser,
              }
            : {
                  errorLoggerCaptureException: displayMissingKeyWarn,
                  errorLoggerSetUser: displayMissingKeyWarn,
              }
    ) as UseErrorLoggerReturn<T>;
};

export const useErrorLogger = (): UseErrorLoggerReturn<boolean> => {
    const config = useRuntimeConfig();
    const hasKey = !!config.public.sentryHost;

    return errorLoggerMethodsFactory(hasKey);
};
